import { Box, Chip, FormControl, InputLabel, MenuItem, Select, Typography, useTheme } from '@mui/material'
import React from 'react'

interface FormTypeSelectProps {
  label?: string
  options: { value: string; label: string; color?: string }[]
  value: string
  onChange: (value: string) => void
  disabled?: boolean
}

const FormTypeSelect: React.FC<FormTypeSelectProps> = ({ label, value, options, onChange, disabled }) => {
  const theme = useTheme()

  return (
    <FormControl
      fullWidth
      sx={{
        maxHeight: '56px', // This sets the FormControl wrapper height
      }}
    >
      <InputLabel>{label ? label : 'Type'}</InputLabel>
      <Select
        value={value || ''}
        label={label ? label : 'Type'}
        onChange={e => onChange(e.target.value)}
        fullWidth
        sx={{
          height: '56px', // Ensure the select itself is limited
          '& .MuiSelect-select': {
            display: 'flex',
            alignItems: 'center',
            padding: '12px',
            boxSizing: 'border-box',
          },
        }}
        disabled={disabled}
      >
        {options.map(option => (
          <MenuItem key={option.value} value={option.value}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Chip
                size="small"
                sx={{
                  backgroundColor: option?.color || 'transparent',
                  width: 14,
                  height: 14,
                }}
              />
              <Typography>{option.label}</Typography>
            </Box>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

export default FormTypeSelect
